###
DRY up Prismic code
###
Prismic = require 'prismic-javascript'
PrismicDOM = require 'prismic-dom'
module.exports =

	# Make a query by a speific type
	typeIs: (type) -> Prismic.Predicates.at('document.type', type)

	# Get the text of a field
	textOf: (attribute) -> PrismicDOM.RichText.asText attribute



// WEBPACK FOOTER //
// ./src/utils/prismic/utils.coffee